// =======================
// src/paginas/telaDeCadastro/telaDeValidacao.js
// =======================
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Container } from '@mui/material';

const TelaDeValidacao = () => {
  const navigate = useNavigate();

  // Redirecionar para a tela de login após 3 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/'); // Mude para o caminho correto da sua tela de login
    }, 3000); // 3000 milissegundos = 3 segundos

    return () => clearTimeout(timer); // Limpa o timer ao desmontar
  }, [navigate]);

  return (
    <Container style={{ textAlign: 'center', marginTop: '50px' }}>
      <Typography variant="h4" gutterBottom>
        Cadastro realizado com sucesso!
      </Typography>
      <Typography variant="body1">
        Você será redirecionado para a tela de login em 3 segundos.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate('/')}>
        Ir para Login
      </Button>
    </Container>
  );
};

export default TelaDeValidacao;
